import { SystemUsersPage } from '@hq/sys-admin';
import { hq, useAuthStore } from '../session';

/**
 * 用户与权限（运营端本租户，门禁 sys:user:view / sys:role:manage）。
 * 页面实现收敛在 `@hq/sys-admin`，本端关闭租户维度（凭令牌自动收口到本租户）。
 */
export default function SystemUsers() {
  const level = useAuthStore((state) => state.profile?.level);
  return <SystemUsersPage hq={hq} viewerLevel={level} />;
}
